<template>
  <div class="w-100">

    <div class="user-data">
      <v-row>
        <v-col cols="12" sm="12" class="attempted-questions-header-col">
          <div class="attempted-questions-header bookmark-filter">
            <div class="att-header-col">
              <div class="show-drop-down drop-I-new single-select">
                <div class="field-data" style="width: 100%;">
                  <v-select v-model="selectedCategory" :items="categories" label="Data" hide-details
                    class="fix-350-width select-chapter-margin-ps" @change="onCategoryChange"></v-select>
                </div>
              </div>
              <div class="show-drop-down drop-I-new single-select">
                <div class="field-data" style="width: 100%;">
                  <v-select v-model="selectedSubject" :items="subjects" label="Subject" hide-details
                    class="fix-350-width select-chapter-margin-ps" @change="onSubjectChange"></v-select>
                </div>
              </div>
              <div class="show-drop-down">
                <div class="field-data">
                  <multi-select allText="All Chapters" :onChange="onChapterChange" :items="chapters" label="Chapter"
                    hide-details widthcss="fix-200"></multi-select>
                </div>
              </div>
            </div>
            <div class="att-header-col" style="display: flex;">
              <v-btn 
                class="cust-btn" 
                color="primary" 
                v-if="allowMultiSelect && selectedQids && selectedQids.length"
                style="margin:0;margin-right:15px;height:42px;"
                @click="publishQuestions"
              >Publish</v-btn>
              <div class="show-drop-down drop-I-new single-select">
                <div class="field-data" style="width: 100%;">
                  <v-select v-model="selectedFilterby" :items="filters" label="" hide-details
                    class="fix-350-width select-chapter-margin-ps" @change="onFilterChange"></v-select>
                </div>
              </div>
              <v-text-field v-model="questionId" @keydown="onSearchQuestion()" solo label="Question Id" dense outlined
                hide-details append-icon="search" autocomplete="off"></v-text-field>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-card class="mx-auto normal-card">
      <div class="data-table-section past-test-institute  prev-test-tb cat-44">
        <v-data-table :headers="headers" :items="items" fixed-header hide-default-header hide-default-footer
          class="elevation-2 cust-table">
          <template v-slot:header="{ props: { headers } }">
            <TableHeader :headers="headers" :orderBy="orderBy" :onSortChange="onSortChange"
              :onHeaderAction="onHeaderAction" />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr style="position: relative" v-for="(item, index) in items" :key="item.schedule_id"
                class="cursor-pointer">
                <td v-if="allowMultiSelect" width="50px">
                  <v-checkbox
                    :input-value="selectedQids.includes(item.question_id)"
                    @change="onSelectRow(item.question_id)"
                  />
                </td>
                <td class="text-center fix-130">
                  <div @click="onQIdClick(item, index)">
                    {{ (item.question_id) || "N.A" }}
                  </div>
                </td>
                <td class="">
                  <div>
                    {{ item.subject_title }}
                  </div>
                </td>
                <td class="">
                  <div>
                    {{ item.chapter_title }}
                  </div>
                </td>
                <td class="">
                  <div>
                    {{ item.question_type }}
                  </div>
                </td>
                <td class="" v-if="questionListType === 'personal_questions'">
                  <div>
                    {{ item.updated_by_name || item.created_by_name }}
                  </div>
                </td>
                <td class="fix-130" v-if="questionListType === 'bookmark_questions'">

                  <v-tooltip left top content-class="cust-new-tooltip-top open-left">
                    <template v-slot:activator="{ on }">
                      <div v-on="on" depressed :class="{
                        'btn-default': true,
                        'ellipsis-txt': true
                      }">
                        {{ item.bookmarked_by_name }}
                      </div>
                    </template>
                    <span> {{ item.bookmarked_by_name }} </span>
                  </v-tooltip>
                </td>
                <td class="dint-120-test">
                  <div class="date-ui">
                    {{ getFormatedDate(item.created_at) }}
                  </div>
                  <div class="time-ui">
                    {{ getFormatedTime(item.created_at) }}
                  </div>
                </td>

              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination :currentPage="currentPage" :totalPage="totalPages" :onPageChange="onPageChange" />
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "../../../utils/constants";

export default {
  name: "ExternalQuestionsList",
  data() {
    return {
      questionTypes: [],
      selectedQids: [],
      headers: [
        {
          text: "QID",
          value: "question_id",
          class: "text-center",
        },
        {
          text: "Subject",
          value: "subject_title",
          class: "",
          hideSort: true,
        },
        {
          text: "Chapter",
          value: "concept_title",
          class: "",
          hideSort: true,
        },
        {
          text: "Question Type",
          value: "question_type",
          class: "",
          class: "text-left",
          type: "multidropdown",
          options: this.questionTypes,
          allText: "All Question Types",
        },
        {
          text: "Uploaded By",
          value: "created_by_name",
          class: "",
          // hideSort: true,
        },
        {
          text: "Bookmarked By",
          value: "bookmarked_by_name",
          class: "",
          // hideSort: true,
        },
        {
          text: "Date Added",
          value: "created_at",
          class: "text-center dint-120-test",
          // hideSort: true,
        },
      ],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      questionId: '',
      selectedSubject: null,
      selectedChapterID: null,
      selectedCategory: null,
      categories: [],
      chapters: [],
      subjects: [],
      selectedQuestionType: [],
      selectedFilterby: 'all_questions',
      filters: [
        { text: 'My Questions', value: 'my_questions' },
        { text: 'All Questions', value: 'all_questions' }
      ],
      questionListType: 'personal-questions',
      pagination: {},
      payload: {}
    };
  },
  mounted() {
    this.checkSessionData();
  },
  computed: {
    ...mapState("userStore", ["user"]),
    filteredItems() {
      const filtered = this.items.filter((item) =>
        item.question.toLowerCase().includes(this.search.toLowerCase())
      );
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return filtered.slice(start, end);
    },
    allowMultiSelect() {
      if (
        this.$route.name !== 'personal-questions' ||
        !constants.AITS_INSTITUTE_ID ||
        !constants.AITS_INSTITUTE_ID.length
      ) {
        return false;
      }

      return constants.AITS_INSTITUTE_ID.indexOf(this.user.institute) >= 0
        && [this.roleIds.ID, this.roleIds.CO, this.roleIds.ED].indexOf(this.user.role_id) >= 0;
    },
  },
  methods: {
    ...mapActions({
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getExternalQuestionsList: "questionStore/getExternalQuestionsList",
      publishQuestionsToMasterDb: "questionStore/publishQuestionsToMasterDb",
      getRefData: "utilStore/getRefData",
    }),
    getProcessedNames(namesString) {
      return [...new Set(namesString.split(','))];
    },
    onSortChange() {
      this.requestQuestions();
    },
    onHeaderAction(e) {
      let headerValue = e.header.value
      let selectedItem = e.data.selectedItems
      let previousSelection = this.selectedQuestionType || [];
      
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        headerValue === "question_type"
      ) {
        if (selectedItem) {
          const newlyChecked = selectedItem.filter(id => !previousSelection.includes(id));
          const newlyUnchecked = previousSelection.filter(id => !selectedItem.includes(id));

          if (newlyChecked.includes(13)) {
            if (!selectedItem.includes(25)) selectedItem.push(25);
          }
        }
        if(!selectedItem.length) {
          this.selectedQuestionType = []  
        } else {
          this.selectedQuestionType = selectedItem;
        }

        const qtHeader = this.headers.find(h => h.value === 'question_type');
        if (qtHeader) {
          qtHeader.options = qtHeader.options.map((x) => {
            const isChecked = this.selectedQuestionType && this.selectedQuestionType.includes(x.value);
            return {
              ...x,
              checked: isChecked
            };
          });
        }
        this.$forceUpdate();
      }
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getFormatedTime(date) {
      return moment.utc(date).format("hh:mm A");
    },
    updatePage(page) {
      this.currentPage = page;
    },
    onSearchQuestion() {
      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.requestQuestions();
      }, 1500);
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestQuestions();
    },
    requestQuestions() {
      this.payload = {};
      if((!this.subjects || this.subjects.length == 0) && this.selectedCategory && this.selectedCategory != 3) {
        this.items = [];
        this.pagination = { page: this.currentPage, pageSize: 0 };
        this.totalPages = 0;
        return;
      }
      let reqData = {
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize || 10,
        },
        category: this.questionListType,
        orderBy: this.orderBy,
        question_details_required: false
      };

      if (this.questionId) {
        reqData.search_question_id = this.questionId;
      }

      if (this.selectedSubject) {
        reqData.subject_ids = [this.selectedSubject];
      } else if (this.subjects && this.subjects.length > 0) {
        reqData.subject_ids = this.subjects.map(s => s.value);
      }

      if (this.selectedChapterID) {
        reqData.chapter_ids = this.selectedChapterID;
      }

      if (this.selectedQuestionType) {
        reqData.question_types = this.selectedQuestionType;
      }

      if (this.selectedFilterby == 'my_questions') {
        reqData.filter_by = 'me';
      }

      this.$root.showLoader = true;
      this.payload = reqData;
      
      // this.saveFiltersToLocalStorage();

      this.getExternalQuestionsList(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.$root.showLoader = false;
          this.items = response.list.map((u) => {
            if (u.bookmarked_by_name) u.bookmarked_by_name = this.getProcessedNames(u.bookmarked_by_name).join(', ')
            return u;
          });

          this.totalPages = response.pagination.pageCount;
          this.pagination = response.pagination;

          this.renderMath();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    checkSessionData() {
      this.defaultData();
    },
    defaultData() {
      const hasStoredFilters = this.loadFiltersFromLocalStorage();
      this.isFirstLoading = true;
      if (!hasStoredFilters) {
        this.selectedCategory = 3;
        this.selectedQuestionType = [];
        this.selectedSubject = null;
        this.selectedChapterID = [];
        this.currentPage = 1;
        this.pageSize = 10;
        this.orderBy = {
          field: "created_at",
          order: "DESC"
        };
        this.questionListType = 'personal_questions';
        this.selectedFilterby = 'all_questions';
      }

      this.getCategory();
      this.getSubjects();
      this.requestGetRefData();

      if (this.$route.name == "personal-questions") {
        this.questionListType = 'personal_questions';
        // this.selectedFilterby = 'all_questions'
        this.filters = [
          { text: 'All Questions', value: 'all_questions' },
          { text: 'My Questions', value: 'my_questions' },
        ];

        const extraCols = [];

        if (this.allowMultiSelect) {
          extraCols.push({ 
            text: "",
            value: "question_id",
            width: "50px",
            hideSort: true,
          });
        }

        this.headers = [
          ...extraCols,
          {
            text: "QID",
            value: "question_id",
            class: "text-center",
          },
          {
            text: "Subject",
            value: "subject_title",
            class: "",
            hideSort: true,
          },
          {
            text: "Chapter",
            value: "concept_title",
            class: "",
            hideSort: true,
          },
          {
            text: "Question Type",
            value: "question_type",
            class: "",
            class: "text-left",
            type: "multidropdown",
            options: this.questionTypes,
            allText: "All Question Types",
          },
          {
            text: "Uploaded By",
            value: "created_by_name",
            class: "",
            // hideSort: true,
          },
          {
            text: "Date Added",
            value: "created_at",
            class: "text-center dint-120-test",
          },
        ]
      } else if (this.$route.name == "bookmark-questions") {
        this.questionListType = 'bookmark_questions';
        // this.selectedFilterby = 'all_questions'
        this.filters = [
          { text: 'All Bookmarks', value: 'all_questions' },
          { text: 'My Bookmarks', value: 'my_questions' },
        ];
        this.headers = [
          {
            text: "QID",
            value: "question_id",
            class: "text-center",
          },
          {
            text: "Subject",
            value: "subject_title",
            class: "",
            hideSort: true,
          },
          {
            text: "Chapter",
            value: "concept_title",
            class: "",
            hideSort: true,
          },
          {
            text: "Question Type",
            value: "question_type",
            class: "",
            class: "text-left",
            type: "multidropdown",
            options: this.questionTypes,
            allText: "All Question Types",
          },
          {
            text: "Bookmarked By",
            value: "bookmarked_by_name",
            class: "fix-130",
            // hideSort: true,
          },
          {
            text: "Date Added",
            value: "created_at",
            class: "text-center dint-120-test",
          },
        ]
      }

      this.requestQuestions();
    },

    getCategory() {
      let reqData = {
        level: 1,
      };

      let me = this;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.categories = response.map((s) => {
            return {
              text: s.title,
              value: s.id,
              selected: false,
            };
          });

          // me.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    categorySelected() {
      this.selectedSubject = null;
      this.selectedChapterID = null;
      this.selectedTopicID = null;
      this.getSubjects();

    },

    getSubjects() {
      let reqData = {
        level: 2,
        parent: this.selectedCategory,
        get_user_subjects: true
      };

      let me = this;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.subjects = response.map((s) => {
            return {
              text: s.title,
              value: s.id,
              selected: false,
            };
          });

          // me.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    subjectSelected() {
      this.selectedChapterID = null;
      this.selectedTopicID = null;
      let reqData = {
        level: 3,
        parent: this.selectedSubject,
      };
      this.topics = [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.chapters = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            c.checked = this.selectedChapterID && this.selectedChapterID.includes(x.id) ? true : false;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },

    chapterSelected(chapterID) {
      this.selectedChapterID = chapterID;
      this.selectedTopicID = null;
    },

    onQIdClick(item, index) {
      const page = ((this.currentPage - 1) * this.pagination.pageSize) + index + 1
      this.payload.pagination = {
        page: page,
        pageSize: this.pageSize || 10,
      }
      this.saveFiltersToLocalStorage();
      this.$router.push({
        name: "question-details",
        params: {
          requiredCall: this.$route.name,
        },
      });
    },

    onFilterChange() {
      this.currentPage = 1;
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        this.requestQuestions();
      }, 500)
    },

    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"] };
      this.getRefData(reqData)
        .then((response) => {
          this.loading = false;
          const qtHeader = this.headers.find(h => h.value === 'question_type');
          if (qtHeader) {
            qtHeader.options = response.QUESTION_TYPE.filter(
              (xx) =>
                xx.id != 14 &&
                xx.id != 15 &&
                xx.id != 16 &&
                xx.id != 17 &&
                xx.id != 18 &&
                xx.id != 20 &&
                xx.id != 21 &&
                xx.id != 23 &&
                xx.id != 24 &&
                xx.id != 22
            ).map((x) => {
              let c = {};
              c.text = x.value;
              c.value = x.id;
              c.checked = this.selectedQuestionType && this.selectedQuestionType.includes(x.id) ? true : false;
              return c;
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getStorageKey() {
      return `questionDetailFilter_${this.$route.name}`;
    },
    saveFiltersToLocalStorage() {
      const filterData = this.payload;
      filterData.selectedFilterby = this.selectedFilterby;
      localStorage.setItem(this.getStorageKey(), JSON.stringify(filterData));
    },
    loadFiltersFromLocalStorage() {
      const storedData = localStorage.getItem(this.getStorageKey());
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        
        this.selectedQuestionType = parsedData.question_types || [];
        this.selectedSubject = (parsedData?.subject_ids?.length && parsedData?.subject_ids?.length === 1) ? parsedData.subject_ids?.[0] : null;
        if(this.selectedSubject) {
         this.subjectSelected();
        }
        this.selectedChapterID = parsedData.chapter_ids || [];
        if(!this.selectedChapterID.length) {
          this.chapters = [];
        }
        
        if(parsedData?.pagination?.page && parsedData?.pagination?.pageSize) {
          this.currentPage = Math.ceil(parsedData.pagination?.page / parsedData.pagination?.pageSize) || 1;
          this.pageSize = parsedData.pagination?.pageSize || 10;
        } else {
          this.currentPage = 1;
          this.pageSize = 10;
        }
        this.orderBy = parsedData.orderBy || {
          field: "created_at",
          order: "DESC"
        };
        this.questionListType = parsedData.category || 'personal_questions';
        this.selectedCategory = parsedData.selectedCategory || 3;
        this.selectedFilterby = parsedData.selectedFilterby || 'all_questions';
        return true;
      }
      return false;
    },
    onCategoryChange(val) {
      if (val) {
          this.selectedSubject = null;
          this.selectedChapterID = []
          this.subjects = [];
          this.chapters = [];
          this.categorySelected();
          this.onFilterChange();
      }
    },
    onSubjectChange(val) {
      if (val) {
        this.selectedChapterID = []
        this.subjectSelected();
        this.onFilterChange();
      }
    },
    onChapterChange(chapterID) {
      this.selectedChapterID = chapterID;
      this.onFilterChange();
    },
    onQuestionTypeChange(val) {
      if (val && val.length) {
        this.onFilterChange();
      }
    },
    onSelectRow(id) {
      const index = this.selectedQids.indexOf(id);
      if (index > -1) {
        this.selectedQids.splice(index, 1);
      } else {
        this.selectedQids.push(id);
      }
    },
    publishQuestions() {
      this.$root.showLoader = true;
      this.publishQuestionsToMasterDb({ qids: this.selectedQids })
        .then((response) => {
          this.$toasted.success(response.message, { icon: "check_circle" });
          this.selectedQids = [];
          this.onFilterChange();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
  },
  watch: {
    $route(to, from) {
      this.defaultData();
    },
    selectedQuestionType(val) {
      if (val) {
        if (!this.isFirstLoading) {
          this.onFilterChange();
        }
        setTimeout(() => {
          this.isFirstLoading = false
        }, 500)
      }
    },

  }
};
</script>
